var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    fill: "#FBFCFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9537 73.9999C61.8503 73.9999 77.169 69.0783 77.169 63.0071C77.169 56.9359 61.8503 52.0143 42.9537 52.0143C24.057 52.0143 8.73828 56.9359 8.73828 63.0071C8.73828 69.0783 24.057 73.9999 42.9537 73.9999Z",
    fill: "#DEEAF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6309 14L70.7693 22.6592V55.6991L43.6309 47.1013V14Z",
    fill: "#B36810"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6311 14L18.6465 22.6592V55.6991L43.6311 47.1013V14Z",
    fill: "#C47212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.785 64.2969L18.6465 55.6991V22.5978L45.785 31.2569V64.2969Z",
    fill: "#3675E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7846 64.2968L18.6462 55.6991L4 65.218L31.1385 73.8772L45.7846 64.2968Z",
    fill: "#649AF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7842 64.2969L70.7688 55.6991V22.5978L45.7842 31.2569V64.2969Z",
    fill: "#508AF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6465 22.5977L43.6311 14L70.7696 22.5977L45.7849 31.2569L18.6465 22.5977Z",
    fill: "#649AF9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.5537 25.7298L53.5383 17.1935L58.7691 18.7902L33.7845 27.388L28.5537 25.7298Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7688 55.6377L45.7842 64.2969L59.015 72.8946L83.9996 64.2354L70.7688 55.6377Z",
    fill: "#4581ED"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6462 55.6991L7.75391 52.8127L18.6462 48.2682V55.6991Z",
    fill: "#4581ED"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7695 55.699H81.1695L70.7695 51.9529V55.699Z",
    fill: "#3675E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.bbef9e7df24a9a7338dc3b241b7bb596.svg";
export { ForwardRef as ReactComponent };